import { defineStore } from "pinia";
import { ref } from "vue";

export const useAiBannerStore = defineStore("aiBanner", () => {
  const hasNewContent = ref<boolean>(false);
  const shouldOpenDrawer = ref<boolean>(false);

  const requestOpenDrawer = () => {
    shouldOpenDrawer.value = true;
  };

  const clearOpenDrawerRequest = () => {
    shouldOpenDrawer.value = false;
  };

  return {
    hasNewContent,
    shouldOpenDrawer,
    requestOpenDrawer,
    clearOpenDrawerRequest,
  };
});
